{{#each reviews}}
  <div class='swiper-slide reviews__item'>
    <h3 class='reviews__subtitle body-accent'>
      {{title}}
    </h3>
    <div class='reviews__content'>
      <p class='reviews__text body-2'>
        {{descr}}
      </p>
      {{#if isLinkedInLink}}
        {{{safeLink}}}
      {{/if}}
    </div>
  </div>
{{/each}}